export class PresetSettingsUI {
  
  public presetElement: JQuery = $('[data-name="preset"]');
  
  public onPresetChange(callback: (value: string) => void) {
    this.presetElement.on('change', () => {
      callback(this.presetElement.val() as string);
    });
  }
  
  public resetInputs() {
    $('[data-name]').each(function () {
      $(this).removeAttr('disabled');
      $(this).removeClass('is-disabled');
    })
  }
}
